import tw from "twin.macro"

const Tagline = tw.div`font-bold leading-none mb-12`

export default Tagline